
const Terms = () => {
  // redirect to external link
window.location.href = 'https://s3-eu-west-2.amazonaws.com/kisdigital/pdf/2026/v1/v1-7/TermsAndConditionsSWB.pdf'
}

export default Terms
